export const downloadLogsKeySessionStorage = "downloadLogsInfo";

export const ERROR_CODES_4XX = {
  BAD_REQUEST: 400,
  FORBIDDEN: 403
};

export const DEFAULT_DEBOUNCE_TIME = 300;
